import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';
import { Message } from '@/modules/messenger/_modules/message/models/Message';
import { User } from '@/modules/user/models/User';

export class MessageSubType extends Enum {
  key!: string;
  getValue!: (message: Message, user?: User) => string;

  static ARCHIVE: MessageSubType = {
    key: 'archive',
    getValue(message: Message, user?: User) {
      return Lang.t(
        user ? 'inbox.conversation-was-archived-by' : 'inbox.conversation-was-archived',
        {
          displayDate: message.humanizedWithOnUpdatedAt,
          userName: user?.name ?? ''
        }
      );
    }
  };

  static UNARCHIVE: MessageSubType = {
    key: 'unarchive',
    getValue(message: Message, user?: User) {
      return Lang.t(
        user ? 'inbox.conversation-was-unarchived-by' : 'inbox.conversation-was-unarchived',
        {
          displayDate: message.humanizedWithOnUpdatedAt,
          userName: user?.name ?? ''
        }
      );
    }
  };

  static ADD_USER: MessageSubType = {
    key: 'add_user',
    getValue(message: Message, user?: User) {
      return Lang.t('inbox.has-joined-this-conversation', {
        userName: user?.name ?? ''
      });
    }
  };

  static REMOVE_USER: MessageSubType = {
    key: 'remove_user',
    getValue(message: Message, user?: User) {
      return Lang.t('inbox.has-left-this-conversation', {
        userName: user?.name ?? ''
      });
    }
  };
}
